import { isWebViewOnMobile } from './user-agent';
import { getUser } from 'app/stores/user-store';
import { getCompany } from 'stores/company-store';
import { EncryptUserHelpers } from '@workivate/tho-web-shared';

const MMHN_TYPES = ['MMHN', 'Manulife Mental Health Network'];
const SECRET_KEY = 'manulife_mhcs_icbt_integration';

export const isManulifeOriginator = () => {
  const originator = getUser().originator || '';

  // If originator is not set, we can't determine if it's Manulife
  if (!originator) {
    return undefined;
  }

  return originator.toLowerCase() === 'manulife';
};

export const getManulifeExternalId = () => {
  const user = getUser();
  const externalId = user.external_ids?.manulife ?? '';

  return externalId;
};

export const isManulifeWebView = () => {
  const isManulifeOrig = isManulifeOriginator();

  // If isManulifeOrig is undefined, we return a default value until we can determine if it's Manulife
  const isManulife = isManulifeOrig === undefined ? true : isManulifeOrig;

  return isWebViewOnMobile() && isManulife;
};

export const isManulifeMMHNCompany = () => {
  const companyType = getCompany()['company_type'] || '';

  return isManulifeOriginator() && MMHN_TYPES.includes(companyType);
};

export const getManulifeUrlWithParam = (url: string) => {
  const MONITORED_URLS = ['https://manulife.myicbt.com/'];

  const externalId = getManulifeExternalId();

  if (!externalId || !MONITORED_URLS.includes(url)) {
    return url;
  }

  const encryptedExternalId = EncryptUserHelpers.encryptUserId(
    externalId,
    SECRET_KEY,
  );

  const newUrl = new URL(url);
  newUrl.searchParams.set('param', encryptedExternalId ?? '');

  return newUrl.toString();
};
